import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

app.initializers.add('flarum-auth-grpc', () => {
  extend(SessionDropdown.prototype, 'items', (items) => {
    items.replace(
      'logOut',
      Button.component(
        {
          icon: 'fas fa-sign-out-alt',
          onclick: () => {
            const forumBaseUrl = app.forum.attribute('baseUrl').replace(/\/$/, '');
            const forumLogoutUrl = new URL(`${forumBaseUrl}/logout`);
            forumLogoutUrl.searchParams.set('token', app.session.csrfToken);

            const accountsLogoutUrl = new URL('https://accounts.wdsj.net/logout');
            accountsLogoutUrl.searchParams.set('callback', forumLogoutUrl.toString());

            window.location.assign(accountsLogoutUrl.toString());
          },
        },
        app.translator.trans('core.forum.header.log_out_button')
      ),
      -100
    );
  });

  extend(HeaderSecondary.prototype, 'items', (items) => {
    items.replace(
      'logIn',
      Button.component(
        {
          className: 'Button Button--link',
          onclick: () => {
            const width = 600;
            const height = 520;
            const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
            const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);

            window.open(
              `${app.forum.attribute('baseUrl')}/auth/grpc`,
              'wdsjGrpcLogin',
              `popup=yes,width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
            );
          },
        },
        app.translator.trans('core.forum.header.log_in_link')
      ),
      0
    );
  });
});
